/**
 * Store links and device detection for the "Get the app" card and /app page.
 */

export const APP_STORE_URL = 'https://apps.apple.com/ca/app/id6808467338';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=ca.nothingtowearclub.app';

// The Median wrapper exposes a window.median bridge (see util/median.js) and
// includes "median" / "gonative" in its user agent. Neither exists in a
// regular browser or during server-side rendering.
export const isInsideMedianApp = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!window.median || /median|gonative/i.test(window.navigator?.userAgent || '');
};

/**
 * @returns {'ios'|'android'|null} which store this device should be sent to,
 * or null for desktop/unknown.
 */
export const getStoreForDevice = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  const ua = window.navigator?.userAgent || '';
  if (/Android/i.test(ua)) {
    return 'android';
  }
  // iPadOS 13+ reports itself as a Mac, so also check for touch support.
  const isIos =
    /iPhone|iPad|iPod/i.test(ua) ||
    (window.navigator?.platform === 'MacIntel' && window.navigator?.maxTouchPoints > 1);
  return isIos ? 'ios' : null;
};
